import React from 'react';
import PropTypes from 'prop-types';

const PlayPause = ({ isPlaying, width, height }) => {
  const dPath = isPlaying ? 'M0 0h6v24H0zM12 0h6v24h-6z' : 'M18 12L0 24V0';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 24"
    >
      <path fillRule="evenodd" d={dPath} />
    </svg>
  );
};

PlayPause.propTypes = {
  isPlaying: PropTypes.bool,
  width:     PropTypes.number,
  height:    PropTypes.number
};

PlayPause.defaultProps = {
  isPlaying: false,
  width:     10,
  height:    14
};

export default PlayPause;
